import React, { Component } from "react";
export default class HeaderCollapseMobile extends Component {

    constructor() {
        super();
        this.state = {
            isLoading: true,
        }
    }
    logOut() {
        localStorage.clear();
    
        window.location.reload();
      }
    render() {
        if (localStorage.getItem('user-info')) {
            let user = JSON.parse(localStorage.getItem('user-info'))

            return (
                <div className="account-menu"> 
                <input type="checkbox" className="user-dropdown" id="user-dropdown-2" hidden/>
                <label className="user-profile-img" for="user-dropdown-2"> 
                <img src={user.user.profile_url ? user.user.profile_url : "https://aawsat.com/themes/custom/aawsatv3/assets-react/img/icon/avatardefault.png"} alt="" />
                </label> 
                <div className="account-menu-list">
                    <ul className="menu vertical">
                        <li><a href="/mybookmarkspage"><i className="icomoon-icon icon-bookmark"></i> محفوظاتي </a></li>
                        <li><a href="/favoritetagspage"><i className="icomoon-icon icon-news"></i> أخباري </a></li>
                        <li><a href="/journey#/mypage"><i className="icomoon-icon icon-news"></i> إدارة أخباري </a></li>
                        <li><a href="/journey#/my_newsletter"><i className="icomoon-icon icon-envelop1"></i>نشراتي البريدية</a></li>
                        <li><a href="/journey#/editprofile"><i className="icomoon-icon icon-user-circle-o"></i> تفاصيل حسابي</a></li>
                        <li><button className="button submit-btn" onClick={this.logOut} ><i className="icomoon-icon icon-sign-out"></i>خروج </button></li>
                    </ul>
                </div>
            </div>
                )
        } else {
            return (
                  <a href="/journey" className="ico-user"><i className="icomoon-icon icon-user-circle-o"></i></a> 
            );
        }
    }
}
